import React, { useEffect, useState } from 'react';
import OrgChart from 'react-orgchart';
import 'react-orgchart/index.css';
import { useCentralCalls } from '@src/rest/CentralCalls';
import { Header, Icon, Label, List, ListProps, ModalProps, Popup, Segment, SegmentProps } from 'semantic-ui-react';
import { DashChartProps } from '../DashCard';
import { ProjectActivityDetailItemContainer } from '../../activities/ProjectActivityDetailItemContainer';
import { ACTIVITY_CRITICALITY, ACTIVITY_CRITICALITY_INFO, ENTITY_ICONS } from '@src/constants/ProductEnums';
import { ActivityCriticalityLabel } from '@src/views/components/activities/ActivityCriticalityLabel';
import { Slider } from 'react-semantic-ui-range';
import Hierarchy from './etc/Hierarchy';
import { Cell, Grid } from 'styled-css-grid';
import { FinePrintMessage } from '@src/views/components/util/messaging/FinePrintMessage';
import { StringOrEmpty } from '@src/views/components/display/StringOrEmpty';
import { TimeService } from '@src/services';
import { ActivityLateCompletionMessage } from '@src/views/components/activities/ActivityLateCompletionMessage';
import { ActivityTimingLabel } from '@src/views/components/activities/ActivityTimingLabel';

const DashActivity: React.FC<DashChartProps> = ({ item, projectVersionId, userId, projectId }) => {
    const [data, setData] = useState(null); // State to store the org chart data
    const { executeStoredProcedure, RunUpdate } = useCentralCalls(); // Assuming this is the API call function
    const [isEditing, setIsEditing] = useState(false); // State to manage edit mode
    const [tempData, setTempData] = useState(data); // Temporary state to hold changes during editing

    const handleEditClick = () => {
        setIsEditing(true);
        setTempData(data); // Set temporary data to current values
    };

    const handleSaveClick = () => {
        setData(tempData); 
        RunUpdate('staticProjectActivity', data.id, { ActivityName : tempData.ActivityName, ActivityDescription: tempData.ActivityDescription });
        setIsEditing(false); // Exit editing mode
    };

    const handleCancelClick = () => {
        setIsEditing(false); // Exit editing mode without saving
    };

    const handleInputChange = (field: keyof typeof tempData, value: string) => {
        setTempData((prev) => ({ ...prev, [field]: value }));
    };
    useEffect(() => {

        const fetchChartData = async () => {
            try {
                //console.log('fetching chart data..');
                //console.log(item);
                //console.log(projectVersionId);
                const data = await executeStoredProcedure('proc_getActivityData', { projectVersionId: projectVersionId, userId: userId, projectId, staticProjectActivityId: '4e5fc4f3-e28e-47a5-a558-001901d71ba0' });
                //console.log(data);
                setData(data[0]);

                console.log('from fetch activity data...')
                console.log(data);
                //setData({ name: "Root", children: data });
                //setData(data);
                //if(data.datasets.length === 1){}
            } catch (error) {
                console.error('Error fetching Gantt data:', error);
            }
        };
        fetchChartData();
    }, [projectVersionId, item]);
    const MyNodeComponent = ({ node }) => (
        <div className="org-node">
            {node.name}
        </div>
    );
    // Render only after data is loaded
    //if (!data) return <div>Loading...</div>;

    return <div style={{ width: '100%', padding: '25px' }}>
        <Grid columns={`1fr auto`}>
        <Cell>
                    {isEditing ? (
                        <div>
                            <input
                                type="text"
                                value={tempData?.ActivityName}
                                onChange={(e) =>
                                    handleInputChange('ActivityName', e.target.value)
                                }
                                style={{ marginBottom: '10px', width: '100%' }}
                            />
                            <textarea
                                value={tempData?.ActivityDescription}
                                onChange={(e) =>
                                    handleInputChange('ActivityDescription', e.target.value)
                                }
                                style={{ width: '100%' }}
                            />
                        </div>
                    ) : (
                        <>
                            <Header dividing as={'h3'} content={data?.ActivityName} />
                            <StringOrEmpty
                                evaluate={data?.ActivityDescription}
                                passValue={
                                    <FinePrintMessage>{data?.ActivityDescription}</FinePrintMessage>
                                }
                                emptyValue={null}
                            />
                        </>
                    )}
                </Cell>
                <Cell>
                    {isEditing ? (
                        <div>
                            <Icon
                                className={'cursor--pointer'}
                                name="save"
                                color="green"
                                onClick={handleSaveClick}
                                title="Save changes"
                            />
                            <Icon
                                className={'cursor--pointer'}
                                name="cancel"
                                color="red"
                                onClick={handleCancelClick}
                                title="Cancel changes"
                            />
                        </div>
                    ) : (
                        <Icon
                            className={'cursor--pointer opacity-hover--80'}
                            name={'edit'}
                            color={'red'}
                            onClick={handleEditClick}
                            title="Edit details"
                        />
                    )}
                </Cell>
            </Grid>
        <Grid columns={`1fr auto`}>
            <Cell>
                <ProjectActivityDetailItemContainer
                    showTooltips={true}
                    icon={ENTITY_ICONS.ACTIVITIES.CRITICALITY_RATING}
                    itemLabel={'Criticality'}
                    tooltip={'The level at which Corval recommends an activity for successful commercialization.'}>
                    <ActivityCriticalityLabel value={ACTIVITY_CRITICALITY_INFO['MODERATE'].VALUE as unknown as ACTIVITY_CRITICALITY} size={'small'} />
                </ProjectActivityDetailItemContainer>
            </Cell>
            <Cell>
                {/* <Icon className={'cursor--pointer opacity-hover--80'} name={'edit'} color={"red"} /> */}
            </Cell>
        </Grid>
        <Grid  columns={`1fr auto`}>
            <Cell>
            <ProjectActivityDetailItemContainer
                                            showTooltips={ false }
                                            icon={ 'clock outline' }
                                            itemLabel={ 'Timeframe' }
                                            tooltip={ 'The timeframe this activity is scheduled for.' }
                                            gridProps={ { columns: `auto minmax(90px, 1fr) auto` } }
                                            iconCellProps={ { middle: true } }
                                            labelCellProps={ { middle: true } }
                                            mainContentCellProps={ { middle: true, className: 'text-right' } }
                                           /> 
            </Cell>
            <Cell>
                <Label circular basic icon={{ name: 'calendar alternate outline' }} content={TimeService.asDisplayDate(data?.startDate)}  />
                <span className={'display--inline-block margin-xs-horizontal'}>to</span>
                <Label circular basic icon={{ name: 'calendar alternate outline' }} content={TimeService.asDisplayDate(data?.endDate)}  />
            </Cell>
        </Grid>

        <Grid  columns={`1fr auto`}>
            <Cell>
            <ProjectActivityDetailItemContainer
                                            showTooltips={ false }
                                            icon={ 'clock outline' }
                                            itemLabel={ 'Timeframe' }
                                            tooltip={ 'The timeframe this activity is scheduled for.' }
                                            gridProps={ { columns: `auto minmax(90px, 1fr) auto` } }
                                            iconCellProps={ { middle: true } }
                                            labelCellProps={ { middle: true } }
                                            mainContentCellProps={ { middle: true, className: 'text-right' } }
                                           /> 
            </Cell>
            <Cell>
                <Label circular basic icon={{ name: 'calendar alternate outline' }} content={TimeService.asDisplayDate(data?.startDate)}  />
                <span className={'display--inline-block margin-xs-horizontal'}>to</span>
                <Label circular basic icon={{ name: 'calendar alternate outline' }} content={TimeService.asDisplayDate(data?.endDate)}  />
            </Cell>
        </Grid>
        {/* <Hierarchy data={[
            {
                id: "1",
                name: "Category 1",
                children: [
                    {
                        id: "1-1",
                        name: "Sub Category 1-1",
                        children: [
                            { id: "1-1-1", name: "Objective 1-1-1" },
                            { id: "1-1-2", name: "Objective 1-1-2" },
                        ],
                    },
                    {
                        id: "1-2",
                        name: "Sub Category 1-2",
                        children: [{ id: "1-2-1", name: "Objective 1-2-1" }],
                    },
                ],
            },
            {
                id: "2",
                name: "Category 2",
                children: [
                    {
                        id: "2-1",
                        name: "Sub Category 2-1",
                        children: [{ id: "2-1-1", name: "Objective 2-1-1" }],
                    },
                ],
            },
        ]} ></Hierarchy>
        <OrgChart tree={{ name: 'category', children: [{ name: 'subCategory', children: [{ name: 'Objective' }] }] }} NodeComponent={MyNodeComponent} />
        <ProjectActivityDetailItemContainer
            showTooltips={true}
            icon={ENTITY_ICONS.ACTIVITIES.CRITICALITY_RATING}
            itemLabel={'Criticality'}
            tooltip={'The level at which Corval recommends an activity for successful commercialization.'}>
            <ActivityCriticalityLabel value={ACTIVITY_CRITICALITY_INFO['MODERATE'].VALUE as unknown as ACTIVITY_CRITICALITY} size={'small'} />
        </ProjectActivityDetailItemContainer> */}
    </div>;
};

export default DashActivity;